<!--价格组 -->  
<template> 
  <div class="store-modal-content">
    <div class="data_action_form">
      <el-card
        class="box-card"
        body-style="padding:0;border:1px solid #E4E7ED"
        v-if="formDataList"
      >
        <v-tabs
          :type="dataActionBox.actionType"
          :activeName="showTabs"
          :name="'jciName'"
          :value="'jciName'"
          :tabslist="formDataList"
          @tabs="
            (val) => {
              showTabs = val
            }
          "
        >
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 主信息 -->
              <div v-if="scope.index == 0">
                <el-form
                  size="mini"
                  inline
                  :model="sendDataInfo"
                  label-width="150px"
                  ref="sendDataInfo"
                  :show-message="false"
                >
                  <el-form-item
                    label="分类名称"
                    prop="btName"
                    :rules="[
                      { required: true, message: '请输入分类名称', trigger: 'blur' },
                    ]"
                  >
                    <label
                      slot="label"
                      :style="$common.labelStyle('分类名称')"
                      v-html="$common.htmlLabel('分类名称')"
                    ></label>
                    <el-input
                      class="form_codition"
                      v-model.trim="sendDataInfo.btName"
                      placeholder="填写分类名称"
             
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="描述" prop="btDesc"    :rules="[
                      { required: true, message: '请输入描述', trigger: 'blur' },
                    ]">
                    <label
                      slot="label"
                      :style="$common.labelStyle('描述')"
                      v-html="$common.htmlLabel('描述')"
                    ></label>
                    <el-input
                      class="form_codition"
                        v-model.trim="sendDataInfo.btDesc"
                      placeholder="填写描述"
             
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <label
                      slot="label"
                      :style="$common.labelStyle('备注')"
                      v-html="$common.htmlLabel('备注')"
                    ></label>
                    <el-input
                      class="form_codition"
                      v-model.trim="sendDataInfo.remark"
                      placeholder="填写备注"
             
                    ></el-input>
                  </el-form-item>
         
                </el-form>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>
    </div>
    <div class="dialog-footer">
      <el-button @click="drawerCancel">取 消</el-button>
      <el-button type="primary" @click="sendDataAction()">保 存</el-button>
    </div>
          <!-- 检索方案 -->
          <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["actionData"],
  name: "goodsCategoryModal",
  data() {
    return {
      dataActionBox: {
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        btName: "",
        btDesc: "",
        remark: "",
      },
      formDataList: [],
      showTabs: "",
      DialogVisible: false, //判断是否打开检索方案弹框
         seTitle: "", //检索方案的名称
         seType: "", //检索方案查询条件字段
         seWidth: "", //检索方案弹框的宽度
         seTitle: "", //检索方案的名称
         sField: "", //赋值字段
         parentSearchData: {}, //检索方案补充的查询列表的查询条件
    }
  },
  methods: {
    async openBox() {
      if (this.actionData.cate == 0) {
        this.showTabs = "新增分类信息"
        this.formDataList = [
          {
            jciName: "新增分类信息",
            jurconfigform: [],
          },
        ]
      } else {
        // 回显数据
        console.log(this.actionData.oldData, 'this.actionData.oldData');
        
        if (this.actionData.oldData) {
          for (let key in this.actionData.oldData) {
            this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
          }
        }

        this.formDataList = [
          {
            jciName: "编辑分类信息",
            jurconfigform: [],
          },
        ]
        this.showTabs = "编辑分类信息"
      }

      this.dataActionBox.actionType = this.actionData.cate
    },
      //检索方案获取的数据清除
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach((item) => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      //获取检索方案弹框宽度
      getSeWidth(e) {
         this.seWidth = e + "%"
      },
      //获取检索方案弹框名称
      getSearchName(e) {
         this.seTitle = e
      },
     // 检索Id, 索引(表格中), 标识
     openSearch(sId, index, type, sField) {
         this.seId = sId //检索方案Id
         this.sField = sField //赋值字段
         this.DialogVisible = true //判断是否打开弹框
         this.seType = type
      },
         //检索方案返回的数据
         changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false
            this.paramValue(val) //赋值字段，赋值
         }
      },
       // 赋值字段
       paramValue(val) {
         let arr = this.sField.split(",")
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item]
         })
      },
           //关闭提取、检索方案弹框关闭 创建键盘事件
           closeChild() {
         addEventListener("keyup", this.keyUp) //创建监听键盘事件
      },
    async sendDataAction() {
      // 表单验证
      this.$refs.sendDataInfo.validate(async (valid) => {
        if (valid) {
          let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
    
          try {
            let responseData
            // 如果是新增
            if (this.dataActionBox.actionType == 0) {
              responseData = await this.$http.deraBgmTypeAdd(sendData)
            }
            // 如果是编辑
            else if (this.dataActionBox.actionType == 1) {
              responseData = await this.$http.deraBgmTypeUpdate(sendData)
            }

            if (responseData.status == 200) {
              this.$message({
                message:
                  this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                type: "success",
              })
              this.$emit("drawerCancel", false)
              this.$emit("toDetail", responseData.result)
            } else {
              this.$message({
                message: responseData.message,
                type: "error",
              })
            }
          } catch (error) {
            console.error("error", error)
            this.$message({
              message: "操作失败",
              type: "error",
            })
          }
        } else {
          this.$message({
            message: "请填写必填项",
            type: "error",
          })
          return false
        }
      })
    },

    drawerCancel() {
      this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", false)
        })
        .catch(() => {})
    },

   
  },
  created() {
    this.openBox()
  },
}
</script>
<style scoped>
.store-modal-content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.data_action_form {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  height: 46px;
  padding: 5px 10px;
  margin-top: 20px;
  border-top: 1px solid #eee;
}
</style>
